enum ProviderPushbackSubTypes {
  REQUIRES_PAYMENT = "Provider Requires Payment Prior to Service"
}

export default ProviderPushbackSubTypes;
